export default __webpack_public_path__ + "static/media/placeholder.afc96671.jpg";